    // Get the input element
    var quantityInput = document.getElementById('quantity');
    // Anchor to Attach Message
    const productAddToCartBtns = document.querySelector('.zip_popup_col')

    // Get all elements with data-quantity attribute
    var quantityButtons = document.querySelectorAll('[data-quantity]');

    // Get the value of the data attribute
    let initVal = document.querySelector('.quantity_block').getAttribute('data-initial-val');
    let minusInvitVal = '';
    // Check if it's not undefined or blank
    if (initVal !== undefined && initVal !== null && initVal.trim() !== '') {
        initVal = initVal; 
        minusInvitVal = initVal-1;
    } 

    // Add event listeners for increment and decrement actions
    quantityButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
            // Prevent the default action of the link
            event.preventDefault();
            event.stopPropagation();

            // Determine whether to increment or decrement based on data-quantity attribute
            var quantityChange;
            if (quantityInput.value === initVal) {
                if (button.getAttribute('data-quantity') !== 'up') {
                    quantityChange = -minusInvitVal;
                } else {
                    quantityChange = 1;
                }
            } else {
                quantityChange = (button.getAttribute('data-quantity') === 'up') ? 1 : -1;
            }

            // Update the input value
          console.log('test: ', Math.max(1, parseInt(quantityInput.value) + quantityChange))
            quantityInput.value = Math.max(1, parseInt(quantityInput.value) + quantityChange);            
            // Validate and update the value
            handleInput();
        });
    });

function createAlert(currentValue) {
    const addToCartButton = document.getElementById('customily-cart-btn');
    
    function createOrUpdateAlert(alertClass, message) {
        const pdpAlert = document.createElement('div');
        pdpAlert.style.backgroundColor = '#c7516c';
        pdpAlert.style.color = '#fff';
        pdpAlert.style.padding = '0.25rem';
        pdpAlert.style.marginBottom = '10px';
        pdpAlert.style.textAlign = 'center';
        pdpAlert.style.fontWeight = 'bold';
        pdpAlert.classList.add(alertClass);
        pdpAlert.textContent = message;

        const existingAlert = document.querySelector(`.pdp-alert.${alertClass}`);
        if (!existingAlert) {
            productAddToCartBtns.parentNode.insertBefore(pdpAlert, productAddToCartBtns);
        } else {
            existingAlert.textContent = message;
            clearTimeout(existingAlert.timerId);
        }

        pdpAlert.timerId = setTimeout(function () {
            pdpAlert.remove();
        }, 2500);
    }

    // Check if currentValue is 1 (for sample) or between 2 and 12
    if (currentValue === 1) {
        createOrUpdateAlert('sample', 'Please note! Only 1 Sample per order');
        updatePdpCheckoutButton(currentValue);
    } else if (currentValue > 1 && currentValue < initVal) {
        createOrUpdateAlert('min', `Minimum Order Quantity is ${initVal}, quantity has been updated`);
        quantityInput.value = initVal;
        currentValue =  quantityInput.value;
        addToCartButton.disabled = false;
    } else {
        // Remove any existing alerts
        document.querySelectorAll('.pdp-alert').forEach(alert => alert.remove());
    }

    if (currentValue >= initVal) {
        updatePdpCheckoutButton(currentValue);
    }
    
    changeText(currentValue);
    if ($('body').hasClass('template-suffix-gourmet-cookie') || $('body').hasClass('template-suffix-tw-gourmet-favor-box')) {
      pricePerItem(quantityInput.value, null, 'GourmetCookie');
    } else if (!$('body').hasClass('template-suffix-gourmet-gift-box-3oz')) {
      pricePerItem(quantityInput.value);
    }else if (!$('body').hasClass('template-suffix-new-gourmet-gift-box-3oz')){
      pricePerItem(quantityInput.value);
    }

  
    if ($('body').hasClass('template-suffix-tw-sugar-gift-program') || $('body').hasClass('template-suffix-tw-brownie-giftset') || $('body').hasClass('template-suffix-gourmet-gift-box-3oz') || $('body').hasClass('template-suffix-new-gourmet-gift-box-3oz') || $('body').hasClass('template-suffix-tw-4.5-giftset')) {
      pricePerItemGift(quantityInput.value);
    }

    if ($('body').hasClass('template-suffix-tw-cookie-jar')) {
      pricePerItemPackItem(quantityInput.value);
    }
  
}

 function changeText(currentValue) {
    console.log('changeText ====', currentValue)
      var getUrl = window.csapps.vd_url + "/api/display-discount-table";
      if (window.csapps.customer) {
        data = {
          product_id: window.csapps.product_id,
          shop: window.csapps.store_id,
          cid: window.csapps.customer.id,
          cemail: window.csapps.customer.email,
          collection_ids: window.csapps.product_collections,
          request_type: '1',
          currency: window.csapps.currency_code
        }
      } else {
        data = {
          product_id: window.csapps.product_id,
          shop: window.csapps.store_id,
          collection_ids: window.csapps.product_collections,
          request_type: '1',
          currency: window.csapps.currency_code
        }
      }
      var api_url = csapps.create_api_url(getUrl, data);
      window.csapps.Data_volume = [];
      //var new_data = window.csapps.all_aiod_api[api_url];
      $.get(api_url, function(new_data){
      var data_final = '';
        if (new_data.data.length > 0 && currentValue != '1') {        
          $(new_data.data).each(function(oo,pp){
             var p_id = $('.offer-wrpper').attr('data-offer_id');
             if(pp.id == p_id){
                $(pp.discount_quantities).each(function(aa,bb){
                   if($('product-form.normal_product').length > 0){
                      var min = 1 
                   }else{
                      var min = pp.discount_quantities[aa].quantity 
                   }
                    var max = pp.discount_quantities[aa + 1] != undefined ? pp.discount_quantities[aa + 1].quantity : 9999999999999;
                     console.log('min: ', min)
                      console.log('max: ', max)
                    
                    if(parseInt(currentValue) >= min && parseInt(currentValue) <= max){
                      data_final = pp.discount_quantities[aa].discount_value
                    }
                  
              });
             }
          });
        } 
        
        var formattedPrice = csapps.formatMoney(data_final * 100, window.theme.money_format); 
        //console.log('formattedPrice: ', formattedPrice)
        var total_qty = document.getElementById('quantity').value;
          function csrundata(){
            if($('.lightly-spaced-row.not-in-quickbuy .csapps-volume-discount-tiers').length) {
              var p1_1 = $('.lightly-spaced-row.not-in-quickbuy .aiod-volume-discount-wrap > div:first-child .csapps-volume-discount-tiers tbody tr:first-child td:last-child').text();
              var p1_1_low = $('.lightly-spaced-row.not-in-quickbuy .aiod-volume-discount-wrap > div:first-child .csapps-volume-discount-tiers tbody tr:last-child td:last-child').text();
              if(p1_1 != ''){
                if ($('body').hasClass('template-suffix-tw-gourmet-gift-program')){
                    $('.quantity_block .productcustomPrice .current-price').fadeOut(200, function(){ 
                      $(this).html('Price per box <strong>' + p1_1 + '</strong> ea.');
                    }).fadeIn(200);
                    setTimeout(function() {
                        $('.productcustomPrice.discount-manage .current-price').html('As low as <strong>'+ p1_1_low + '</strong> ea.');  
                    },1000);                  
                  $('.each_price').text(p1_1);
                } else if ($('body').hasClass('template-suffix-tw-sugar-gift-program')){
                  console.log('p1_1_lowkkkk');
                   $('.quantity_block .productcustomPrice .current-price').fadeOut(200, function() {
                     $(this).html('Price per box <strong>' + p1_1 + '</strong> ea.');
                   }).fadeIn(200);
                  // $('.product-info__price .productcustomPrice .current-price').html('As low as '+ p1_1 + ' Each. <br><strong>Minimum order of 6</strong>');
                  setTimeout(function() {
                    $('.productcustomPrice.discount-manage .current-price').html('As low as'+ p1_1_low + ' ea.');
                  },1000);        
                  $('.each_price').text(p1_1);
                }else if($('body').hasClass('template-suffix-tw-brownie')){
                  $('.productcustomPrice.discount-manage .current-price').fadeOut(200, function(){
                    $(this).html('As low as <strong>' + p1_1 + '</strong> ea.');
                  }).fadeIn(200);
                  $('.each_price').text(p1_1);
                } else {
                  $('.productcustomPrice .current-price').fadeOut(200, function(){
                    $(this).html('As low as <strong>' + p1_1 + '</strong> ea.');
                  }).fadeIn(200);
                  $('.each_price').text(p1_1);
                }
              }
            }
          }    
        var has_static_table = $('.satic-table-wrrap').length;
        if(has_static_table < 1){
         if ($('body').hasClass('template-suffix-tw-gourmet-gift-program')) {
          var lowest_price = $('.lightly-spaced-row.not-in-quickbuy .aiod-volume-discount-wrap > div:first-child .csapps-volume-discount-tiers tbody tr:last-child td:last-child').text();    
          $('.quantity_block .productcustomPrice .current-price').fadeOut(200, function() {
            $(this).html('Price per box <strong>' + formattedPrice + '</strong> ea.');
          }).fadeIn(200);
          setTimeout(function() { 
            $('.productcustomPrice.discount-manage .current-price').html('As low as <strong>' + lowest_price + '</strong> ea.'); 
          },1000);  
            // $('.product-info__price .productcustomPrice .current-price').html(formattedPrice + ' Each. Minimum of 6');
          } else if ($('body').hasClass('template-suffix-tw-sugar-gift-program')) {
            $('.quantity_block .current-price').fadeOut(200, function() {
              $(this).html('Price per box <strong>' + formattedPrice + '</strong> ea.');
            }).fadeIn(200);
            // $('.product-info__price .productcustomPrice .current-price').html('As low as '+ formattedPrice + ' Each. <br><strong>Minimum order of 6</strong>');
          }else if($('body').hasClass('template-suffix-tw-brownie-giftset') || $('body').hasClass('template-suffix-tw-brownie')){
           var p1_first = $('.lightly-spaced-row.not-in-quickbuy .aiod-volume-discount-wrap > div:first-child .csapps-volume-discount-tiers tbody tr:first-child td:last-child').text().trim();
              var displayPrice = formattedPrice;
              if (formattedPrice === '$0.00' && p1_first !== '') {
                  displayPrice = p1_first;
              }
              $('.product-form .price-area').fadeOut(200, function() {
                  $(this).find('.current-price').html(
                      'Price per box <strong>' + displayPrice + '</strong> ea.'
                  );
              }).fadeIn(200);
          }else {
            $('.product-form .price-area').fadeOut(200, function() {
              $(this).find('.current-price').html('<strong>' + formattedPrice + '</strong> ea.');
           }).fadeIn(200); 
          }
          if (currentValue === 1){
              csrundata(); 
          }else{
            if($('body').hasClass('template-suffix-tw-brownie')){
              var p1_first = $('.lightly-spaced-row.not-in-quickbuy .aiod-volume-discount-wrap > div:first-child .csapps-volume-discount-tiers tbody tr:first-child td:last-child').text();
              $('.productcustomPrice.discount-manage .current-price').fadeOut(200, function(){
                  $(this).html('As low as <strong>' + p1_first + '</strong> ea.');
              }).fadeIn(200);
            }
            $('.each_price').text(csapps.formatMoney(data_final*total_qty * 100, window.theme.money_format));
         }
        } 
      });
    }

  document.addEventListener('on:variant:change', (event) => {
     var curentVariant = $('.new_col').find('input[type="radio"]:checked').val();
     var currentValue = parseInt(quantityInput.value);

     if ($('body').hasClass('template-suffix-gourmet-cookie') || $('body').hasClass('template-suffix-tw-gourmet-favor-box')) {
       pricePerItem(quantityInput.value, curentVariant, 'GourmetCookie');
     } else if (!$('body').hasClass('template-suffix-gourmet-gift-box-3oz')) {
       pricePerItem(quantityInput.value, curentVariant);
     }else if(!$('body').hasClass('template-suffix-new-gourmet-gift-box-3oz')){
       pricePerItem(quantityInput.value, curentVariant);
     }

    if ($('body').hasClass('template-suffix-tw-brownie-giftset') || $('body').hasClass('template-suffix-gourmet-gift-box-3oz') || $('body').hasClass('template-suffix-tw-4.5-giftset') || $('body').hasClass('template-suffix-new-gourmet-gift-box-3oz')) {
       pricePerItemGift(quantityInput.value , curentVariant);
     }

     if ($('body').hasClass('template-suffix-tw-cookie-jar')) {
      pricePerItemPackItem(quantityInput.value);
    }

     
     changeText(currentValue);
     // var x1_1 = $('.lightly-spaced-row.not-in-quickbuy .csapps-volume-discount-tiers tbody tr:first-child td:first-child').text().trim();
     // if (x1_1 === '1-12' && $('body').hasClass('template-suffix-tw-gourmet-gift-program')) {
     //    setTimeout(function(){
     //      $('.csapps-volume-discount-tiers tbody tr:first-child td:first-child').text('Sample');
     //    },50);  
     //  }

   
      if ($('body').hasClass('template-suffix-tw-cake-jar')){
        var selectedPack = $('.tw-cake-jar input[type="radio"]:checked').val();
        $('.pack-size').text(selectedPack);
        var selectedIndex = $('.tw-cake-jar input[type="radio"]').index(
            $('.tw-cake-jar input[type="radio"]:checked')
          ) + 1;

          var total = $('.csapps-table tbody tr td')
            .eq(selectedIndex)
            .find('.money')
            .data('total');

          $('.each_price').text(total);
      }
  });

function pricePerItem(currentValue,curentVariant,GourmetCookie) {
  console.log('======================================= Add here')
  var curentVariant = $('.new_col').find('input[type="radio"]:checked').val();
  var curentQuantity = parseInt(currentValue);

  var rowIndex = 0;
  var colIndex = 0;
  if(curentVariant){
    if(curentVariant.indexOf('1.5 oz') != -1){
      rowIndex = 0;
    } else if (curentVariant.indexOf('3 oz') != -1) {
      rowIndex = 1;
    } else if (curentVariant.indexOf('4.5 oz') != -1) {
      rowIndex = 2;
    }
  }
  console.log('GourmetCookie ===', GourmetCookie);
  if(GourmetCookie){
    if (curentQuantity < 12) {
      colIndex = 1;
    }else if (curentQuantity >= 12 && curentQuantity <= 24) {
      colIndex = 2;
    } else if (curentQuantity >= 25 && curentQuantity <= 99) {
      colIndex = 3;
    } else if (curentQuantity >= 100 && curentQuantity <= 399) {
      colIndex = 4;
    } else if (curentQuantity >= 400 && curentQuantity <= 999) {
      colIndex = 5;
    } else if (curentQuantity >= 1000 && curentQuantity <= 4999) {
      colIndex = 6;  
    } else if (curentQuantity >= 5000) {
      colIndex = 7; 
    }
  } else{
    if (curentQuantity < 12) {
      colIndex = 1;
    }else if (curentQuantity >= 12 && curentQuantity <= 24) {
      colIndex = 2;
    } else if (curentQuantity >= 25 && curentQuantity <= 99) {
      colIndex = 3;
    } else if (curentQuantity >= 100 && curentQuantity <= 499) {
      colIndex = 4;
    } else if (curentQuantity >= 500 && curentQuantity <= 999) {
      colIndex = 5;
    } else if (curentQuantity >= 1000 && curentQuantity <= 4999) {
      colIndex = 6;  
    } else if (curentQuantity >= 5000) {
      colIndex = 7; 
    }
  }
  if(curentVariant){
        if(curentVariant.indexOf('1.5 oz') != -1){
         var class_new = '.new_col.col_four_img.oz-153'
        } else if (curentVariant.indexOf('3 oz') != -1) {
          var class_new = '.new_col.col_four_img.oz-153'
        } else if (curentVariant.indexOf('4.5 oz') != -1) {
          var class_new = '.new_col.col_four_img.oz-4-5-decadent-flavors'
        }
      }
  
    var value = $('.new-static-table tbody tr:eq(' + rowIndex + ') td:eq(' + colIndex + ')').text();
    
    if($('body').hasClass('template-suffix-tw-cake-jar') || $('body').hasClass('template-suffix-tw-gourmet-gift-program') || $('body').hasClass('template-suffix-tw-sugar-gift-program') || $('body').hasClass('template-suffix-gourmet-gift-box-3oz') || $('body').hasClass('template-suffix-new-gourmet-gift-box-3oz')){ 
    }else{
      if($(class_new + ' input').is(':checked') && !$(class_new).hasClass('hide_variant')) {
       var updatedValue_1 = (parseFloat(value.replace('$', '')) + 0.30).toFixed(2);
        $('.product-form .price-area').find('.current-price').html('<strong>$' + updatedValue_1 + ' </strong>ea.'); 
      }else {
        $('.product-form .price-area').find('.current-price').html('<strong>' + value + ' </strong>ea.');  
      }
    }
    
    var value_new = $('.csapps-table.new-csapps-table tbody tr:eq(' + rowIndex + ') td:eq(' + colIndex + ') .money:not(:has(del))').text().trim();
    if($('body').hasClass('template-suffix-tw-cake-jar') || $('body').hasClass('template-suffix-tw-gourmet-gift-program') || $('body').hasClass('template-suffix-tw-sugar-gift-program') || $('body').hasClass('template-suffix-gourmet-gift-box-3oz') || $('body').hasClass('template-suffix-new-gourmet-gift-box-3oz')){
    }else{
       var num_value = parseFloat(value_new.replace('$', '')); // Add code here @CS Team for each_price 05-11-2025
       if($('.csapps-table.new-csapps-table').length > 0){
        if($(class_new + ' input').is(':checked') && !$(class_new).hasClass('hide_variant')) {
          var updatedValue = (parseFloat(value_new.replace('$', '')) + 0.30).toFixed(2);
          $('.product-form .price-area').find('.current-price').html('<strong>$' + updatedValue + ' </strong>ea.'); 
          var num_value = (parseFloat(value_new.replace('$', '')) + 0.30).toFixed(2); // Add code here @CS Team for each_price 05-11-2025
        }else {
          $('.product-form .price-area').find('.current-price').html('<strong>' + value_new + ' </strong>ea.'); 
        }
      }
      // Add code here @CS Team for each_price 05-11-2025 below 3 line
      if($('.each_price').length){
        $('.each_price').text(csapps.formatMoney(num_value*curentQuantity * 100, window.theme.money_format));
      }

    }


    // Add code here @CS Team for each_price
    // if($('.new_col.col_four_img input').is(':checked') && !$('.new_col.col_four_img').hasClass('hide_variant') && $('body').hasClass('template-suffix-gourmet-cookie')) {
    //   var num_value = (parseFloat(value_new.replace('$', '')) + 0.25).toFixed(2);
    // } else {
    //   var num_value = parseFloat(value_new.replace('$', ''));  
    // }
    // if($('.each_price').length){
    //   $('.each_price').text(csapps.formatMoney(num_value*curentQuantity * 100, window.theme.money_format));
    // }
    // Over code here @CS Team for each_price

    
  }

function pricePerItemGift(currentValue,curentVariant) {
  var giftcurentVariant = $('.new_col').find('input[type="radio"]:checked').val();
  var giftcurentQuantity = parseInt(currentValue);

    var giftrowIndex = 0;
    var giftcolIndex = 0;
    if($('body').hasClass('template-suffix-tw-4.5-giftset')){

        if(giftcurentVariant){
      if(giftcurentVariant.indexOf('1.5 oz') != -1){
        giftrowIndex = 0;
      } else if (giftcurentVariant.indexOf('3 oz') != -1) {
        giftrowIndex = 1;
      } else if (giftcurentVariant.indexOf('4.5 oz') != -1) {
        giftrowIndex = 1;
      }
    }

    }else{
    if(giftcurentVariant){
      if(giftcurentVariant.indexOf('1.5 oz') != -1){
        giftrowIndex = 0;
      } else if (giftcurentVariant.indexOf('3 oz') != -1) {
        giftrowIndex = 1;
      } else if (giftcurentVariant.indexOf('4.5 oz') != -1) {
        giftrowIndex = 2;
      }
    }
    }

    
    if (giftcurentQuantity < 2) {
      giftcolIndex = 1;
    }else if (giftcurentQuantity >= 2 && giftcurentQuantity <= 40) {
      giftcolIndex = 2;
    } else if (giftcurentQuantity >= 41 && giftcurentQuantity <= 75) {
      giftcolIndex = 3;
    } else if (giftcurentQuantity >= 76 && giftcurentQuantity <= 149) {
      giftcolIndex = 4;
    } else if (giftcurentQuantity >= 150) {
      giftcolIndex = 5; 
    }
  
     var giftValue = $('.satic-table-wrrap.gift-pdp tbody tr:eq(' + giftrowIndex + ') td:eq(' + giftcolIndex + ') .csapps-price:not(.csapps-price-full)').text();
     var giftprice_last = $('.satic-table-wrrap.gift-pdp tbody tr:eq(' + giftrowIndex + ') td:last .csapps-price:not(.csapps-price-full)').text();
     console.log('giftprice_last ===', giftprice_last)
     var num_value = parseFloat(giftValue.replace('$', ''));
     var total_qty = document.getElementById('quantity').value;
     var extraValue = $('body').hasClass('template-suffix-tw-brownie-giftset') ? 3 : 3.60;
      if($('.new_col.col_four_img input').is(':checked') && !$('.new_col.col_four_img').hasClass('hide_variant')) {
      
       var updatedValue_1 = (parseFloat(giftValue.replace('$', '')) + extraValue).toFixed(2);
       num_value = parseFloat(updatedValue_1.replace('$', ''));

       $('.quantity_block .productcustomPrice .current-price').fadeOut(200, function(){ 
        $(this).html('Price per box <strong>$' + updatedValue_1 + '</strong> ea.');
        }).fadeIn(200);

         var updatedValue = (parseFloat(giftprice_last.replace('$', '')) + extraValue).toFixed(2);
        // $('.productcustomPrice.discount-manage .current-price').html('As low as <strong>'+ giftprice_last + '</strong> ea.');  
        //  $('.product-info__price .productcustomPrice .current-price').html('As low as '+ giftprice_last + ' Each.');
        $('.each_price').text(csapps.formatMoney(num_value*total_qty * 100, window.theme.money_format));
        
      }else {
        $('.quantity_block .productcustomPrice .current-price').fadeOut(200, function(){ 

          $(this).html('Price per box <strong>' + giftValue + '</strong> ea.');
        }).fadeIn(200);

        // $('.productcustomPrice.discount-manage .current-price').html('As low as <strong>'+ giftprice_last + '</strong> ea.'); 
        // $('.product-info__price .productcustomPrice .current-price').html('As low as '+ giftprice_last + ' Each.');
        $('.each_price').text(csapps.formatMoney(num_value*total_qty * 100, window.theme.money_format));
      }
    
  }

function pricePerItemPackItem(currentValue,curentVariant) {
  var giftcurentVariant = $('.new_col').find('input[type="radio"]:checked').val();
  var giftcurentQuantity = parseInt(currentValue);

    var giftrowIndex = 0;
    var giftcolIndex = 0;

    if(giftcurentVariant){
      if(giftcurentVariant.indexOf('1-Pack') != -1){
        giftrowIndex = 0;
      } else if (giftcurentVariant.indexOf('4-Pack') != -1) {
        giftrowIndex = 1;
      }
    }
    
    if (giftcurentQuantity >= 1 && giftcurentQuantity <= 1) {
      giftcolIndex = 1; // 1–4 column
    } else if (giftcurentQuantity >= 2 && giftcurentQuantity <= 48) {
      giftcolIndex = 2; // 5–24 column
    } else if (giftcurentQuantity >= 49) {
      giftcolIndex = 3; // 25+ column
    } else {
      giftcolIndex = 1; // QTY header (for invalid quantity)
    }
  
    var giftValue = $('.satic-table-wrrap.gift-pdp tbody tr:eq(' + giftrowIndex + ') td:eq(' + giftcolIndex + ')').text();
    var giftprice_first = $('.satic-table-wrrap.gift-pdp tbody tr:eq(' + giftrowIndex + ') td:eq(1)').text();
    var num_value = parseFloat(giftValue.replace('$', ''));
    var total_qty = document.getElementById('quantity').value;

    $('.quantity_block .productcustomPrice .current-price').fadeOut(200, function(){ 
      $(this).html('Price per box <strong>' + giftValue + '</strong>');
    }).fadeIn(200);
    $('.productcustomPrice.discount-manage .current-price').html('As low as <strong>'+ giftprice_first + '</strong>'); 
    $('.product-info__price .productcustomPrice .current-price').html('As low as '+ giftprice_first);
    $('.each_price').text(csapps.formatMoney(num_value*total_qty * 100, window.theme.money_format));
  }

    // Function to validate and update the input value
    function validateAndUpdateValue() {
        //console.log("Validate and update value called");
        var currentValue = parseInt(quantityInput.value);
        createAlert(currentValue)
    }

    function handleInput() {
        // Validate the input value
        //console.log("Handle Input Called");
        setTimeout(validateAndUpdateValue, 500);
    }

    async function sampleCheck() {
        try {
            const res = await fetch('/cart.js');
            const data = await res.json();

            const count = (() => {
                let sampleCount = 0;
                for (let item of data.items) {
                    if (item.quantity === 1) {
                        sampleCount++;
                        //console.log('Number Of Samples' + sampleCount);
                        if (sampleCount >= 1) return true;
                    } else if (item.quantity >= 2 && item.quantity <= minusInvitVal) {
                        return true;
                    }
                }
                return false; // return 0 if none of the conditions are met
            });
            return count();
        } catch (error) {
            console.error('Error fetching cart data:', error);
            return false; // Return 0 if there's an error fetching data
        }
    }

    // create a function that checks the checkoutbutton with the id of customily-cart-btn and if it is enabled, set it to disabled
    async function updatePdpCheckoutButton(currentValue) {
      console.log('updatePdpCheckoutButton ==============================================')
        const addToCartButton = document.getElementById('customily-cart-btn');
        const sampleInCart = await sampleCheck();
        console.log("Sample In Cart? " + sampleInCart);
       if($('body').hasClass('template-suffix-tw-sugar-gift-program') || $('body').hasClass('template-suffix-tw-gourmet-gift-program')){
             document.getElementById('customily-cart-btn').classList.add('customBtnCS');
            addToCartButton.disabled = false;
       }else if (currentValue === 1 && sampleInCart || currentValue < initVal && sampleInCart) {
            console.log('000000000000000000')
            document.getElementById('customily-cart-btn').classList.remove('customBtnCS');
            addToCartButton.disabled = true;
        } else {
            console.log('False')
            document.getElementById('customily-cart-btn').classList.add('customBtnCS');
            addToCartButton.disabled = false;
        }
    }

    // Add an event listener for input changes
    quantityInput.addEventListener('change', handleInput);

    document.addEventListener('theme:cartchanged', () => {
        setTimeout(function () {
            //console.log('Theme Event Triggered - cartchanged');
            updatePdpCheckoutButton();
        }, 2800)
    });



function got_length(){
  if($('.squareswatchaddon input').length){       
    $('.squareswatchaddon input').change(function(){
      var quantityVal = document.getElementById('quantity').value;
      if (quantityVal < initVal ) {
        $('input#quantity').val(initVal)
        updatePdpCheckoutButton(initVal)
      }
    });
    
  }else{
   setTimeout(function(){ got_length(); }, 500);
  }
}
got_length();
